import React,{useContext} from 'react';
import { GoArrowRight } from "react-icons/go";
import axios from 'axios';
import { LoginPopupContext } from '../../loginpopup/LoginPopupContext';

function PostPropertyStrip() {
    const [isPopupVisible, setIsPopupVisible] = useContext(LoginPopupContext);
    const fetchStoressessionvalues = async (loginId) => {
        try {
            const response = await axios.post(
                'https://keralaplots.com/Official/create_session.php',
                { loginId: loginId },
                {
                    headers: {
                        'Content-Type': 'application/json', // Ensure the server knows you're sending JSON
                    },
                    withCredentials: true, // Include cookies in the request
                }
            );
            console.log(response.data);  // Log the response from the server
        } catch (error) {
            //toast.error(error.response?.data?.error || "An error occurred. Please try again.");
        }
    };

    return (
        <>
            <section id='postPropertyStrip'>
                <div className="container">
                    <div className="postPropertyStripMain">
                        <h2>List Your Property with Kerala Plots</h2>
                        <p>Showcase your property to buyers across Kerala with ease.</p>
                        <a 
                        onClick={(e) => {
                            e.preventDefault(); // Prevent default navigation
                            const Tokenval = localStorage.getItem("jwtToken"); 
                            if (!Tokenval) {
                                setIsPopupVisible(true); // Show login popup
                            } else {
                                fetchStoressessionvalues(localStorage.getItem("login_id"));
                                window.open("https://keralaplots.com/keralaplots/postProperty/post-basic-info.html?id=0", "_blank");
                            }
                        }}
                        >Post Property <GoArrowRight /></a>
                    </div>
                </div>
            </section>
        </>
    );
}

export default PostPropertyStrip;
